import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IRobot,
    RobotHostingType,
    RobotType,
    RobotTypeAttended,
    RobotTypeUnattended,
} from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import {
    IODataArray,
    ODATA_COUNT_KEY,
    ODataService,
} from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class RobotService extends ODataService<IRobot, number> {
    protected _endpoint = '/odata/Robots';

    constructor(http: HttpClient) {
        super(http, MapperService.robotMap);
    }

    public getRobotTypes(hostingType: RobotHostingType = RobotHostingType.Standard): RobotType[] {
        const filter = (v: string) => !isNaN(Number(v));

        let robotTypes = Object.keys(RobotTypeAttended).filter(filter);

        if (hostingType === RobotHostingType.Standard) {
            robotTypes = Object.keys(RobotTypeUnattended).filter(filter).concat(robotTypes);
        }
        return robotTypes.map(v => Number(v)) as unknown as RobotType[];
    }

    public getMachineNameToLicenseKeyMappings(): Observable<any> {
        return (this._http.get(`${this._endpoint}/UiPath.Server.Configuration.OData.GetMachineNameToLicenseKeyMappings`))
            .pipe(
                map(response => this._mapData(response)),
            );
    }

    public convertToFloating(robotId: number): Observable<any> {
        return this._http.post(`${this._endpoint}/UiPath.Server.Configuration.OData.ConvertToFloating`, JSON.stringify({ robotId }));
    }

    public userNameSuggest = (searchTerm: string = '', fetchSize = 20, skip = 0) => {
        const queryOptions: ODataQueryOptions = {
            orderBy: ['Username'],
            top: fetchSize,
            skip,
            filter: {
                Username: {
                    contains: searchTerm,
                },
            },
        };

        const endpoint = `${this._endpoint}/UiPath.Server.Configuration.OData.GetUsernames${this.getQueryString(queryOptions)}`;

        return this._http
            .get<IODataArray<string>>(endpoint)
            .pipe(
                map(
                    res => ({
                        data: res.value.map(
                            robotName => ({
                                id: robotName,
                                text: robotName,
                            }),
                        ),
                        total: res[ODATA_COUNT_KEY],
                    }),
                ),
            );
    }

    public deleteBulk(keys: number[]) {
        const payload = JSON.stringify({ 'robotIds': keys });

        return this._http.post(`${this._endpoint}/UiPath.Server.Configuration.OData.DeleteBulk`, payload);
    }
}
